import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";
import Loader from "../../components/Loader";

function Staff() {
  const [staffList, setStaffList] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStaff();
  }, [status]);

  const fetchStaff = async () => {
    setLoading(true);
    try {
      const params = {};
      if (status) params.status = status;

      const res = await api.get("/staff", { params });
      setStaffList(res.data);
    } catch (err) {
      console.error(err.response || err.message);
      alert("Failed to fetch staff");
    } finally {
      setLoading(false);
    }
  };

  const handleResetCredentials = async (id) => {
    try {
      const res = await api.post(`/staff/${id}/reset-credentials`);
      alert(
        `✅ New Credentials Generated!\n\n📧 Email: ${res.data.credentials.email}\n🔑 Password: ${res.data.credentials.password}`
      );
    } catch (err) {
      console.error(err.response || err.message);
      alert("Failed to reset credentials");
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="bg-gray-50 p-6 md:p-10">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between items-center bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-2xl shadow-lg p-6 mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          👥 Staff Management
        </h1>
        <Link
          to="/staff/add"
          className="mt-4 sm:mt-0 bg-white text-purple-600 font-semibold px-5 py-2.5 rounded-lg shadow hover:bg-purple-100 transition-all duration-200"
        >
          + Add New Staff
        </Link>
      </div>

      {/* Filter Section */}
      <div className="mb-6 flex flex-col sm:flex-row justify-between items-center gap-4">
        <h2 className="text-xl font-semibold text-gray-700">
          Staff Overview
        </h2>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="border border-gray-300 rounded-lg px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 text-gray-700"
        >
          <option value="">All Statuses</option>
          <option value="Active">Active</option>
          <option value="Suspended">Suspended</option>
          <option value="Pending">Pending</option>
        </select>
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto bg-white rounded-xl shadow-md border border-gray-200">
        <table className="min-w-full text-sm text-gray-700">
          <thead className="bg-gray-100 text-gray-800 text-sm uppercase font-semibold">
            <tr>
              <th className="px-6 py-3 text-left">Name</th>
              <th className="px-6 py-3 text-left">Email</th>
              <th className="px-6 py-3 text-left">Phone</th>
              <th className="px-6 py-3 text-left">Status</th>
              <th className="px-6 py-3 text-left">Registered</th>
              <th className="px-6 py-3 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {staffList.length > 0 ? (
              staffList.map((staff, index) => (
                <tr
                  key={staff.id}
                  className={`border-b hover:bg-purple-50 transition-colors ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-6 py-3 font-medium">{staff.name || "—"}</td>
                  <td className="px-6 py-3">{staff.email || "—"}</td>
                  <td className="px-6 py-3">{staff.phone || "—"}</td>
                  <td className="px-6 py-3">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold ${
                        staff.status === "Active"
                          ? "bg-green-100 text-green-700"
                          : staff.status === "Suspended"
                          ? "bg-red-100 text-red-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}
                    >
                      {staff.status || "Active"}
                    </span>
                  </td>
                  <td className="px-6 py-3">
                    {new Date(staff.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-3 text-center space-x-2">
                    <Link
                      to={`/staff/${staff.id}`}
                      className="inline-block bg-green-500 text-white px-3 py-1.5 rounded-md text-xs font-semibold hover:bg-green-600 transition"
                    >
                      View
                    </Link>
                    <button
                      onClick={() => handleResetCredentials(staff.id)}
                      className="inline-block bg-purple-600 text-white px-3 py-1.5 rounded-md text-xs font-semibold hover:bg-purple-700 transition"
                    >
                      Reset
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="px-6 py-10 text-center text-gray-500 italic"
                >
                  No staff found. Click{" "}
                  <b className="text-purple-600">“Add New Staff”</b> to create
                  one.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Staff;
